import * as React from "react";

function SvgWhalr(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="915 175 585 300"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        fill="#d8ab4d"
        d="M1034.3 217.63c48.13-.12 96.26-.04 144.39-.04 24.08 41.75 48.16 83.52 72.28 125.25l.12.21c-24.36 41.45-48.09 83.28-72.24 124.86-48.33-83.34-96.28-166.91-144.55-250.28z"
      />
      <path
        fill="#b50b1c"
        d="M1178.69 217.59c48.18-.03 96.37-.02 144.56 0-24.06 41.77-48.15 83.52-72.28 125.25-24.12-41.73-48.2-83.5-72.28-125.25z"
      />
      <path
        fill="#f04a00"
        d="M1323.25 217.59c33.93.01 67.86-.09 101.79.04-40.91 71.23-82.1 142.3-123.08 213.49-17.09-29.28-33.97-58.68-50.87-88.07l-.12-.21c24.13-41.73 48.22-83.48 72.28-125.25z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgWhalr);
